import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FpKeyFeaturesComponent } from '../common/fp-key-features/fp-key-features.component';
import { FpCtaComponent } from '../common/fp-cta/fp-cta.component';
import { FpProcessComponent } from '../common/fp-process/fp-process.component';
import { TranslateModule } from '@ngx-translate/core';
// import { FpTeamComponent } from '../common/fp-team/fp-team.component';

@Component({
    selector: 'app-features',
    imports: [FpKeyFeaturesComponent, FpCtaComponent, FpProcessComponent, TranslateModule],
    templateUrl: './features.component.html',
    styleUrl: './features.component.scss'
})
export class FeaturesComponent {}